import React, { Component } from 'react'
import Select from 'react-select';
import { components } from 'react-select'
import { Modal, Form, Col, Button, Row } from 'react-bootstrap';

import SelectDropDown from '../selectdropdown/SelectDropDown';

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import MultiSelect from "react-multi-select-component";
import { withRouter } from "react-router-dom";

class EditEmployeeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPassword: false,
        };
    }

    render() {

        const roles = this.props.stateData.roles || [];
        const selectedRole = this.props.stateData.selectedRole || "";
        const selRole = roles.find((r) => String(r.id) === String(selectedRole));
        const isTeacher = !!(selRole && (selRole.role_name || "").trim().toLowerCase().includes("teacher"));
        const roleName = selRole ? (selRole.role_name || "") : "";
        const avatarSrc = this.props.stateData.selectedImageBase64 || this.props.stateData.profileImage;

        let subjectSelectAll = true;
        let subjectLabelledBy = "Select";
        let subjectdisablesearch = false;
        if (this.props.stateData.subjectOptions.length > 0) {
            subjectSelectAll = true;
            subjectdisablesearch = false;
        }
        else {
            subjectdisablesearch = true;
            subjectSelectAll = false;
            subjectLabelledBy = "Subjects"
        }

        let classSelectAll = true;
        let classLabelledBy = "Select";
        let classdisablesearch = false;
        if (this.props.stateData.classesOptions.length > 0) {
            classSelectAll = true;
            classdisablesearch = false;
        }
        else {
            classdisablesearch = true;
            classSelectAll = false;
            classLabelledBy = "Classes"
        }

        const sectionsOptions = this.props.stateData.sectionsOptions || [];
        let sectionSelectAll = true;
        let sectionLabelledBy = "Select";
        let sectiondisablesearch = false;
        if (sectionsOptions.length > 0) {
            sectionSelectAll = true;
            sectiondisablesearch = false;
        }
        else {
            sectiondisablesearch = true;
            sectionSelectAll = false;
            sectionLabelledBy = "Sections"
        }

        const FIN = {
            label: { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5, display: "block" },
            input: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 14, color: "#1f2937", background: "#f9fafb", width: "100%", height: 44 },
            err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
            heading: { fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 16, display: "flex", alignItems: "center", gap: 7 },
            btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 8, padding: "7px 18px", fontSize: 12.5, fontWeight: 600, cursor: "pointer" },
            req: { color: "#dc2626" },
        };

        return (
            <Modal {...this.props} size="lg" aria-labelledby="edit-employee-modal" centered dialogClassName="edu-emp-modal">
                <style>{`
                  .edu-emp-modal .modal-content { border: none !important; border-radius: 16px; overflow: hidden; padding: 0 !important; }
                  .edu-emp-modal .modal-body { padding: 0 !important; overflow: visible; }
                  .edu-emp-modal .modal-dialog { max-width: 760px; }
                  .edu-emp-modal .modal-body .mb-3 { margin-bottom: 0.55rem !important; }
                  .edu-profile-upload-wrapper:hover .edu-profile-upload-overlay { opacity: 1 !important; }
                  .modules-branchdd { position: relative; z-index: 100; }
                  .modules-branchdd .dropdown-content { position: absolute; z-index: 9999 !important; background: #fff; }
                  .modules-dropup { position: relative; z-index: 1; }
                  .modules-dropup:focus-within { z-index: 9999; }
                  .modules-dropup .dropdown-content { top: auto; bottom: 100%; }
                  .modules-dropup .select-item { padding: 8px 10px; margin-bottom: 4px; }
                `}</style>
                <Modal.Body>
                    <div style={{ position: "relative", display: "flex", flexWrap: "wrap", alignItems: "stretch" }}>

                        {/* Close */}
                        <button type="button" onClick={this.props.onHide} aria-label="Close" style={{ position: "absolute", top: 14, right: 14, zIndex: 5, background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#475569", width: 32, height: 32, borderRadius: "50%", cursor: "pointer", fontSize: 15, lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <i className="fal fa-times" />
                        </button>

                        {/* LEFT — avatar / summary */}
                        <div style={{ flex: "0 0 240px", maxWidth: 240, width: "100%", background: "linear-gradient(160deg,#213046 0%,#131c2b 100%)", color: "#fff", padding: "34px 24px", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                            <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "#f8c52c", marginBottom: 24 }}>
                                <i className="fal fa-user-edit mr-2" />Edit Employee
                            </div>

                            <div
                                className="edu-profile-upload-wrapper"
                                onClick={() => this.fileInputRef.click()}
                                style={{ position: "relative", width: 112, height: 112, borderRadius: "50%", border: "3px solid #f8c52c", overflow: "hidden", cursor: "pointer", background: "rgba(255,255,255,0.08)", display: "flex", alignItems: "center", justifyContent: "center" }}
                            >
                                {avatarSrc ? (
                                    <img src={avatarSrc} alt="Profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                ) : (
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", color: "#fff" }}>
                                        {this.props.stateData.uploadingImage ? (
                                            <span className="spinner-border spinner-border-sm" style={{ color: "#f8c52c" }} />
                                        ) : (
                                            <>
                                                <i className="fal fa-camera" style={{ fontSize: 22, color: "#f8c52c" }} />
                                                <span style={{ fontSize: 10, marginTop: 4, fontWeight: 600 }}>Upload</span>
                                            </>
                                        )}
                                    </div>
                                )}
                                <div className="edu-profile-upload-overlay" style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "rgba(0,0,0,0.45)", color: "#fff", fontSize: 10, textAlign: "center", padding: "3px 0", opacity: 0, transition: "opacity 0.2s" }}>
                                    Change
                                </div>
                            </div>

                            {avatarSrc ? (
                                <button type="button" onClick={this.props.handleImageRemove} style={{ marginTop: 10, background: "transparent", border: "none", color: "#f8c52c", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                                    <i className="fal fa-times-circle mr-1" />Remove photo
                                </button>
                            ) : null}

                            <div style={{ fontSize: 17, fontWeight: 800, marginTop: 16, wordBreak: "break-word", lineHeight: 1.25 }}>
                                {this.props.stateData.Username || "Employee"}
                            </div>
                            {roleName ? (
                                <div style={{ marginTop: 8, fontSize: 12, fontWeight: 700, background: "#f8c52c", color: "#213046", borderRadius: 20, padding: "4px 14px" }}>
                                    {roleName}
                                </div>
                            ) : null}

                            <div style={{ marginTop: 22, fontSize: 12, fontWeight: 700, color: "#fff", display: "flex", alignItems: "center", gap: 7, opacity: 0.9 }}>
                                <i className="fal fa-id-badge" style={{ color: "#f8c52c" }} />Employee Details
                            </div>
                            <div style={{ marginTop: 6, width: 40, height: 2, background: "#f8c52c", borderRadius: 2 }} />
                            <p style={{ marginTop: 12, fontSize: 11.5, color: "rgba(255,255,255,0.7)", lineHeight: 1.6, marginBottom: 0 }}>
                                Update the employee's profile, login and role details on the right.
                            </p>
                            {this.props.stateData.selectedImageName ? (
                                <div style={{ marginTop: 16, fontSize: 11, opacity: 0.85, wordBreak: "break-all" }}>
                                    <i className="fal fa-file-image mr-1" />{this.props.stateData.selectedImageName}
                                </div>
                            ) : null}

                            <input
                                type="file"
                                ref={ref => this.fileInputRef = ref}
                                style={{ display: "none" }}
                                accept="image/*"
                                onChange={this.props.handleImageChange}
                            />
                        </div>

                        {/* RIGHT — form */}
                        {/* <div style={{ flex: "1 1 360px", background: "#fff", padding: "30px 30px 10px" }}> */}
                        {/* RIGHT — form */}
                        <div style={{ flex: "1 1 360px", background: "#fff", padding: "30px 30px 10px" }}>
                            {/* RIGHT — form */}
                            <div style={{ flex: "1 1 360px", minWidth: 0, background: "#fff", padding: "30px 30px 10px" }}>
                                <Row>
                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Branch</label>
                                        <MultiSelect
                                            className="modules-branchdd"
                                            overrideStrings={{ "allItemsAreSelected": "All Branches are selected.", "selectSomeItems": "Select Branches" }}
                                            disableSearch={(this.props.stateData.branchOptions || []).length === 0}
                                            hasSelectAll={(this.props.stateData.branchOptions || []).length > 0}
                                            options={this.props.stateData.branchOptions || []}
                                            value={this.props.stateData.preSelectedBranches || []}
                                            onChange={(e) => this.props.handleMultipleSelectInputChange(e, "branches")}
                                            labelledBy={"Branches"}
                                        />
                                        {this.props.stateData.branchError ? <span style={FIN.err}>{this.props.stateData.branchError}</span> : null}
                                    </Col>

                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Employee Name <span style={FIN.req}>*</span></label>
                                        <input style={FIN.input} type="text" placeholder="Employee Name" name="user_name" maxLength={50} onChange={this.props.handleInputChange} autoComplete="off" value={this.props.stateData.Username} />
                                        {this.props.stateData.usernameError ? <span style={FIN.err}>{this.props.stateData.usernameError}</span> : null}
                                    </Col>

                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Username <span style={FIN.req}>*</span></label>
                                        <input style={FIN.input} type="text" placeholder="User Name" name="login_user_name" maxLength={20} onChange={this.props.handleInputChange} autoComplete="off" value={this.props.stateData.loginUsername} />
                                        {this.props.stateData.loginUsernameError ? <span style={FIN.err}>{this.props.stateData.loginUsernameError}</span> : null}
                                    </Col>

                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Employee Password <span style={FIN.req}>*</span></label>
                                        <div style={{ position: "relative" }}>
                                            <input style={{ ...FIN.input, paddingRight: 36 }} type={this.state.showPassword ? "text" : "password"} placeholder="Password" maxLength={15} onChange={this.props.handleInputChange} autoComplete="new-password" name="password" value={this.props.stateData.password} />
                                            <i
                                                className={this.state.showPassword ? "far fa-eye" : "far fa-eye-slash"}
                                                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                                style={{ position: "absolute", right: 12, top: 14, cursor: "pointer", color: "#6b7280" }}
                                            />
                                        </div>
                                        {this.props.stateData.passwordError ? <span style={FIN.err}>{this.props.stateData.passwordError}</span> : null}
                                    </Col>

                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Email</label>
                                        <input style={FIN.input} type="email" placeholder="Email" name="email" maxLength={100} onChange={this.props.handleInputChange} autoComplete="off" value={this.props.stateData.email} />
                                        {this.props.stateData.emailError ? <span style={FIN.err}>{this.props.stateData.emailError}</span> : null}
                                    </Col>

                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Contact No</label>
                                        <input style={FIN.input} type="text" inputMode="numeric" maxLength={10} placeholder="Mobile No" name="contact_no" onChange={this.props.handleInputChange} autoComplete="off" value={this.props.stateData.contact_no} />
                                        {this.props.stateData.contact_noError ? <span style={FIN.err}>{this.props.stateData.contact_noError}</span> : null}
                                    </Col>

                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Role <span style={FIN.req}>*</span></label>
                                        <select style={FIN.input} name="role" onChange={this.props.handleInputChange} value={selectedRole}>
                                            <option value="">Select Role</option>
                                            {roles.map(item => (
                                                <option key={item.id} value={item.id}>{item.role_name}</option>
                                            ))}
                                        </select>
                                        {this.props.stateData.roleError ? <span style={FIN.err}>{this.props.stateData.roleError}</span> : null}
                                    </Col>

                                    {isTeacher ? (
                                        <Col lg={6} md={12} sm={12} className="mb-3">
                                            <label style={FIN.label}>Select Class <span style={FIN.req}>*</span></label>
                                            <MultiSelect
                                                className="modules-dropup"
                                                overrideStrings={{ "allItemsAreSelected": "All Classes are selected.", "selectSomeItems": classLabelledBy }}
                                                disableSearch={classdisablesearch}
                                                hasSelectAll={classSelectAll}
                                                options={this.props.stateData.classesOptions}
                                                value={this.props.stateData.preSelectedClasses}
                                                onChange={(e) => this.props.handleMultipleSelectInputChange(e, "classes")}
                                                labelledBy={"Classes"}
                                            />
                                            {this.props.stateData.classError ? <span style={FIN.err}>{this.props.stateData.classError}</span> : null}
                                        </Col>
                                    ) : null}

                                    {isTeacher ? (
                                        <Col lg={6} md={12} sm={12} className="mb-3">
                                            <label style={FIN.label}>Select Section</label>
                                            <MultiSelect
                                                className="modules-dropup"
                                                overrideStrings={{ "allItemsAreSelected": "All Sections are selected.", "selectSomeItems": sectionLabelledBy }}
                                                disableSearch={sectiondisablesearch}
                                                hasSelectAll={sectionSelectAll}
                                                options={sectionsOptions}
                                                value={this.props.stateData.preSelectedSections || []}
                                                onChange={(e) => this.props.handleMultipleSelectInputChange(e, "sections")}
                                                labelledBy={"Sections"}
                                            />
                                            {this.props.stateData.sectionError ? <span style={FIN.err}>{this.props.stateData.sectionError}</span> : null}
                                        </Col>
                                    ) : null}

                                    {isTeacher ? (
                                        <Col lg={6} md={12} sm={12} className="mb-3">
                                            <label style={FIN.label}>Select Subjects</label>
                                            <MultiSelect
                                                className="modules-dropup"
                                                overrideStrings={{ "allItemsAreSelected": "All Subjects are selected.", "selectSomeItems": subjectLabelledBy }}
                                                disableSearch={subjectdisablesearch}
                                                hasSelectAll={subjectSelectAll}
                                                options={this.props.stateData.subjectOptions}
                                                value={this.props.stateData.preSelectedSubjects}
                                                onChange={(e) => this.props.handleMultipleSelectInputChange(e, "subjects")}
                                                labelledBy={"Subjects"}
                                            />
                                            {this.props.stateData.selectedsubjectsError ? <span style={FIN.err}>{this.props.stateData.selectedsubjectsError}</span> : null}
                                        </Col>
                                    ) : null}
                                </Row>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", marginTop: 4, paddingTop: 12, borderTop: "1px solid #f1f5f9" }}>
                                {this.props.stateData.currentStep == 5 ? (
                                    <p style={{ color: "#059669", fontWeight: 600, marginBottom: 8 }}>Data Saved Successfully</p>
                                ) : this.props.stateData.submitError ? (
                                    <p style={{ color: "#dc2626", marginBottom: 8 }}>{this.props.stateData.submitError}</p>
                                ) : null}
                                <button type="button" style={FIN.btnPrimary} onClick={this.props.handleFormSubmit}>
                                    {this.props.stateData.loadingSpinner == 1 ? <span className="spinner-border spinner-border-sm" /> : <i className="fas fa-save" />}
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

export default

    (EditEmployeeModal);
